import React from 'react';
import PropTypes from 'prop-types';
import { ReviewRequestButtonWithModal } from 'common/Workqueue/ReviewRequestButtonWithModal';
import { useAssigneeOptions, REQUEST_UNASSIGNED } from 'common/Workqueue/hooks/useAssigneeOptions';
import { useEnrollmentReviewReasonOptions } from '../hooks/useEnrollmentReviewReasonOptions';
import { useReviewEnrollmentRequest } from '../hooks/useUpdateEnrollmentRequest';

const ReviewEnrollmentRequest = ({
enrollmentRequest,
}) => {
  const planId = enrollmentRequest?.plan.id;
  const assigneeOptions = useAssigneeOptions('enrollments');
  const reviewReasonsOptions = useEnrollmentReviewReasonOptions(planId);

  const reviewEnrollmentRequest = useReviewEnrollmentRequest();

  const handleSubmit = async (data) => reviewEnrollmentRequest(
    enrollmentRequest,
    data.review_reason,
    data.in_review_note,
    data.assignee === REQUEST_UNASSIGNED || !data.assignee ? null : data.assignee,
  );

  const initialModalValues = {
    review_reason: enrollmentRequest.enrollment_review_reason,
    in_review_note: enrollmentRequest.in_review_note,
    assignee: enrollmentRequest?.assignee?.id,
  };

  return (
    <>
      <ReviewRequestButtonWithModal
        row={enrollmentRequest}
        onSubmit={handleSubmit}
        modalTitle="Review enrollment request"
        reviewReasonsOptions={reviewReasonsOptions}
        assigneeOptions={assigneeOptions}
        initialModalValues={initialModalValues}
      />
    </>
    );
  };

export default ReviewEnrollmentRequest;

ReviewEnrollmentRequest.propTypes = {
  enrollmentRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
    plan: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    in_review_note: PropTypes.string.isRequired,
    enrollment_review_reason: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    assignee: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
